import { Injectable } from "@angular/core";

export abstract class BaseAction {
    constructor() {}
    public abstract doAction(action?: any, event?: any, options?: any): any;
    public abstract getActionConfiguration(): any
    public abstract getActionDetail(): any
}